import type { ValuesOf } from '@shared/types';

export const PurchaseState = {
  Default: 'default',
  ConnectWallet: 'connectWallet',
  SwitchChain: 'switchChain',
  Pending: 'pending',
  InProgress: 'inProgress',
  Error: 'error',
  Success: 'success',
  Approval: 'approval',
  InsufficientFunds: 'insufficientFunds',
} as const;

export type PurchaseState = ValuesOf<typeof PurchaseState>;

export interface PurchaseModel {
  state: PurchaseState;
}
